import React from 'react';
import useCredentials from "./../hooks/useCredentials";
import useLogin from "./../hooks/useLogin";
import CredentialsContext from './../contexts/CredentialsContext';

/*
  Компонент обёртка. Предоставляет значение контекста CredentialsContext
*/
export default function Credentials({children}){
  const {credentials, setCredentials} = useCredentials();

  const {isLogged, isLoaded} = useLogin(credentials);

  if (isLoaded) {
    return <CredentialsContext.Provider children={children} value={{credentials, setCredentials}} />
  } else return <></>

  // return <CredentialsContext.Provider children={children} value={{credentials, setCredentials}} />
}

